'use strict';

var d3 = require('d3');
var $ = require('jquery');
var _ = require('lodash');
/**
 * Fare Box rectangle
 *
 * Draws Fare Box With Fare Class and Fare
 *
 * @param d3Helper
 * @param tooltip
 * @returns {Function}
 * @constructor
 */
var RectangleWithText = function RectangleWithText(d3Helper, tooltip) {
  return function (tooltipContentProvider) {
    var params, scales, data, tip;
    var tooltipId = _.uniqueId('fare-rectangle-tooltip-');
    var dataIsSet = false;
    var rootClassName = 'fare-rectangle';
    var className = rootClassName;
    var tooltipSelector;
    var tooltipInitialized;
    var tooltipAdded = tooltipContentProvider !== undefined;
    if (tooltipAdded) {
      var tooltipClasses = tooltipContentProvider.cssClass ? tooltipContentProvider.cssClass + ' ' + tooltipId : tooltipId;
      tip = tooltip(tooltipContentProvider, tooltipClasses);
      tooltipSelector = '.' + tooltipId;
    }
    var mouseOverHandler = function mouseOverHandler(d) {
      this.parentNode.appendChild(this);
      if (tooltipAdded && d.toolTipContent !== undefined) {
        tip.show(d, this);
        tip.setPositionNearCursor(tooltipSelector);
        d3Helper.adjustTooltipTopPosition();
      }
    };
    var mouseMoveHandler = function mouseMoveHandler() {
      if (tooltipAdded) {
        tip.setPositionNearCursor(tooltipSelector);
        d3Helper.adjustTooltipTopPosition();
      }
    };
    var mouseOutHandler = function mouseOutHandler() {
      if (tooltipAdded) {
        tip.hideAndAdjustPosition();
      }
    };

    /**
     * Binds event to group DOM element
     * @param selection
     */
    function bindEvents(selection) {
      if (tooltipAdded) {
        selection.on('mouseout', mouseOutHandler);
        selection.on('mousemove', mouseMoveHandler);
        selection.on('mouseover', mouseOverHandler);
      }
    }

    /**
     * Unbinds event from a group DOM element
     * @param selection
     */
    function unbindEvents(selection) {
      selection.on('mouseout', null);
      selection.on('mousemove', null);
      selection.on('mouseover', null);
    }
    function isFillIndicatorRect(d) {
      return params.isDisplayIndicator && d.isShowIndicator && d.isFillIndicator;
    }
    var rectangle = function rectangle(container) {
      var mainGroup = d3Helper.findChildrenByClass(container, className);
      if (mainGroup.empty()) {
        mainGroup = d3Helper.createGroupElement(container, [rootClassName, className].join(' '));
      } else {
        mainGroup.html('');
      }
      var singleRectangle = mainGroup.selectAll(className).data(data);
      var g = singleRectangle.enter().append('g').call(bindEvents).attr({
        transform: function transform(d) {
          return 'translate(' + d.x + ',' + d.y + ')';
        }
      });
      g.append('rect').attr('width', function style(d) {
        return d.width;
      }).attr('height', 30).attr('rx', 2).attr('ry', 2).attr('class', function style(d) {
        return isFillIndicatorRect(d) ? d.rectangleStyle + ' ' + d.rectangleIndicatorStyle : d.rectangleStyle;
      });
      var text = g.append('text').attr('x', 6).attr('y', 15).attr('class', function (d) {
        return isFillIndicatorRect(d) ? d.textStyle + ' ' + d.textIndicatorStyle : d.textStyle;
      });
      text.append('tspan').text(function (d) {
        return d.rbd;
      }).attr('x', 6).attr('y', 15);
      text.append('tspan').text(function (d) {
        return Math.round(d.totalFare);
      }).attr('x', 25).attr('y', 15);
      g.append('line').attr('class', function (d) {
        return isFillIndicatorRect(d) ? d.rectangleStyle + ' ' + d.rectangleIndicatorStyle : d.rectangleStyle;
      }).attr('x1', 22).attr('x2', 22).attr('y1', 0).attr('y2', 18);
      if (params.isDisplayIndicator) {
        // if additional flag/marking is needed on the rectangle
        g.append('rect').attr('rx', 2).attr('ry', 2).attr('class', function style(d) {
          return d.isShowIndicator && !d.isFillIndicator ? d.rectangleIndicatorStyle : '';
        }).attr('action', function style(d) {
          if (d.isShowIndicator && d.isFillIndicator) {
            return 'remove';
          } else if (d.isShowIndicator) {
            return 'retain';
          }
          return 'remove';
        });

        // increase the width of rect other than the above additional rect-flags
        // which has the flag isExpandedIndicator equal to false
        // in addition, remove the unwanted rects
        singleRectangle.selectAll('rect').attr('width', function (d) {
          if (this.getAttribute('action') === 'remove') {
            this.remove();
          } else if (this.getAttribute('action') !== 'retain') {
            return this.parentNode.getBBox().width;
          }
        });
      } else {
        singleRectangle.selectAll('rect').attr('width', function () {
          return this.parentNode.getBBox().width;
        });
      }
      singleRectangle.exit().call(unbindEvents).remove();
      if (!tooltipInitialized && tooltipAdded) {
        singleRectangle.call(tip);
        tooltipInitialized = true;
      }
    };
    rectangle.withData = function (value) {
      dataIsSet = true;
      data = _.reject(value, function (d) {
        return _.isNil(d.totalFare);
      });
      return rectangle;
    };
    rectangle.params = function (value) {
      params = value;
      return rectangle;
    };
    rectangle.scales = function (value) {
      scales = value;
      return rectangle;
    };
    rectangle.destroy = function () {
      if (tooltipAdded) {
        $(tooltipSelector).remove();
      }
    };
    return rectangle;
  };
};
RectangleWithText.$inject = ['d3Helper', 'ChartElementsTooltip'];
module.exports = RectangleWithText;